// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d570c3e2","821":"58d92728"}[chunkId] + ".chunk.js";
};